import { useEffect, useState } from 'react';
import { learnerTourService } from '../services/learnerTourService';

const helpCache = new Map<string, boolean>();

/**
 * True when this page key has an active tour with at least one step.
 * A null key (home, static pages, and anything else with no tour) is false immediately.
 */
export function usePageHelpAvailable(pageKey: string | null): boolean {
  const [available, setAvailable] = useState(() => {
    if (!pageKey) return false;
    return helpCache.get(pageKey) ?? true;
  });

  useEffect(() => {
    if (!pageKey) {
      setAvailable(false);
      return undefined;
    }
    const cached = helpCache.get(pageKey);
    if (cached !== undefined) {
      setAvailable(cached);
      return undefined;
    }
    let cancelled = false;
    setAvailable(true);
    void learnerTourService.getPublicTour(pageKey, 'en').then((tour) => {
      const ok = Boolean(tour?.steps?.length);
      helpCache.set(pageKey, ok);
      if (!cancelled) setAvailable(ok);
    });
    return () => {
      cancelled = true;
    };
  }, [pageKey]);

  return available;
}
